import React, { ReactElement } from 'react';
import type { Route } from 'next';
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// import Link from 'next/link';
import classNames from 'classnames/bind';
import Breadcrumbs from 'components/Breadcrumbs';
import useWindowSize from 'utils/hooks/useWindowSize';
import styles from 'sections/Benefits/BrandReliability/components/SectionHeader/SectionHeader.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = (): ReactElement => {
  const { width: screenWidth } = useWindowSize();

  return (
    <section className={cn('header')}>
      <div className={cn('container')}>
        <Breadcrumbs
          mTop={64}
          mode="light"
          links={[
            { title: 'Benefits', href: '/benefits' as Route},
            { title: 'Brand Reliabilty', href: '' as Route},
          ]}
        />
        <div className={cn('header__content')}>
          <div className={cn('header__title-box')}>
            <h1 className={cn('header__title')}>
              Brand Reliability Benefits
            </h1>
            {screenWidth >= 769 
              ?
              <p className={cn('header__title-description')}>
                <span>Join a trusted global network that guarantees your credibility and positions your brand as</span>
                <span>a reliable partner in freight forwarding</span>
              </p>
              :
              <p className={cn('header__title-description')}>
                Join a trusted global network that guarantees your credibility and positions your 
                brand as a reliable partner in freight forwarding
              </p>
            }
          </div>
          {/* (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774) */}
          {/* <div className={cn('header__buttons')}>
            <Link className={cn('header__button-join')} href="/membership">
              Join our Membership
            </Link>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default SectionHeader;